export const createBoundedTtlSet = ({ ttlMs, maxSize }) => {
    const entries = new Map()

    const prune = now => {
        entries.forEach((createdAt, key) => {
            if (now - createdAt >= ttlMs) entries.delete(key)
        })
    }

    const has = (key, now = Date.now()) => {
        prune(now)
        return entries.has(key)
    }

    const add = (key, now = Date.now()) => {
        entries.set(key, now)
        while (entries.size > maxSize) {
            entries.delete(entries.keys().next().value)
        }
    }

    const clear = () => entries.clear()

    return { has, add, clear }
}
